import { Object } from "core-js";

export default {
  namespaced: true,
  state: {
    expire_at: 0,
    name: "",
    head: 0,
    body: 0,
    leftArm: 0,
    rightArm: 0,
    leg: 0,
    bg: 0,
    emptyBox1: 0,
    emptyBox2: 0
  },
  getters: {
    completionRate(state) {
      let completionRate = 0;
      completionRate += state.head ? 20 : 0;
      completionRate += state.body ? 24 : 0;
      completionRate += state.leftArm ? 12 : 0;
      completionRate += state.rightArm ? 12 : 0;
      completionRate += state.leg ? 20 : 0;
      completionRate += state.bg ? 12 : 0;
      //completionRate += state.emptyBox1 ? 0 : 0;
      //completionRate += state.emptyBox2 ? 0 : 0;
      return completionRate;
    },
    status(state, getters, rootState) {
      const status = {
        ap: 0,
        dp: 0,
        mb: 0
      };
      const parts = rootState.parts.parts;
      Object.keys(state).forEach(key => {
        const id = state[key] - 1;
        let part = parts[key];
        part = part ? part[id] : null;
        if (part) {
          status.ap += part.ap;
          status.dp += part.dp;
          status.mb += part.mb;
        }
      });
      return status;
    }
  },
  mutations: {
    load(state) {
      const now = Date.now();
      if (localStorage.getItem("magrobo")) {
        const magrobo = JSON.parse(localStorage.getItem("magrobo"));
        if (now > magrobo.expire_at) {
          localStorage.removeItem("magrobo");
        } else {
          Object.assign(state, magrobo);
        }
      }
    },
    save(state) {
      state.expire_at = Date.now() + 1000 * 60 * 5; // = 5min.
      localStorage.setItem("magrobo", JSON.stringify(state));
    },
    reset(state) {
      state.expire_at = Date.now() + 1000 * 60 * 5;
      state.name = "";
      state.head = 0;
      state.body = 0;
      state.leftArm = 0;
      state.rightArm = 0;
      state.leg = 0;
      state.bg = 0;
      state.emptyBox1 = 0;
      state.emptyBox2 = 0;
      localStorage.setItem("magrobo", JSON.stringify(state));
    },
    item(state, args) {
      state[args[0]] = args[1];
    },
    name(state, args) {
      state.name = args;
    },
    all(state, args) {
      Object.keys(args).forEach(key => {
        state[key] = key.match(/name|expire/) ? args[key] : parseInt(args[key]);
      });
    }
  },
  actions: {
    load({ commit }) {
      commit("load");
      window.setInterval(() => {
        commit("save");
      }, 30 * 1000);
    },
    setItem({ commit }, args) {
      commit("item", args);
      commit("save");
    },
    setName({ commit }, args) {
      commit("name", args);
      commit("save");
    },
    async setAll({ commit }, args) {
      commit("all", args);
      commit("save");
    }
  }
};
